export const daysBeforeLabel = (daysBefore: number): string =>
  `${daysBefore} ${daysBefore === 1 ? 'day' : 'days'} before`

export const formatHour = (hour: number): string => {
  const suffix = hour < 12 ? 'AM' : 'PM'
  const display = hour % 12 === 0 ? 12 : hour % 12
  return `${display}:00 ${suffix}`
}

export const hourToSendAtTime = (hour: number): number =>
  Math.floor(Date.UTC(1970, 0, 1, hour, 0, 0) / 1000)

export const sendAtTimeToHour = (sendAtTime: number): number =>
  new Date(sendAtTime * 1000).getUTCHours()
